import { apiRequest } from "@/services/api-client";
import { InventoryPokemonsOutput } from "types/web-app";

export const listInventoryPokemons = () =>
  apiRequest<InventoryPokemonsOutput>("/inventory-pokemons");
